module.exports = __webpack_public_path__ + "img/PhoneCircleIcon.409111e5.svg";